<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <b-container fluid class="px-4 pb-5">
      <b-row class="justify-content-center mx-auto" style="max-width: 1400px;">
        <kn-sideMenu></kn-sideMenu>
        <main role="main" class="col-md-9 pl-md-5">
          <div class="content-card">
            <h2 class="section-title">
              <span class="blue-accent"></span>Δεκαετία {{ decade }}
            </h2>
            <b-row class="mt-4 px-2">
              <!-- Loop through the years of the selected decade and create a modern card for each -->
              <b-col v-for="year in years" :key="year" cols="12" sm="6" md="4" lg="3" class="mb-4">
                <router-link :to="`/${decade}/${year}`" class="no-underline">
                  <div class="year-card">
                    <div class="year-card-inner">
                      <i class="fa-regular fa-folder-open folder-icon"></i>
                      <h4 class="year-text">{{ year }}</h4>
                    </div>
                  </div>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </main>
      </b-row>
    </b-container>
    <kn-footer></kn-footer>
  </div>
</template>

<script>
import jumbotron from './jumbotron.vue';
import sideMenu from './sideMenu.vue';
import footer from './footer.vue'

export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  },
  props: {
    decade: {
      type: Number, // The decade should now be a number
      required: true,
    }
  },
  computed: {
    years() {
      const startYear = this.decade; // Use the passed decade as a number
      const currentYear = new Date().getFullYear(); // Get the current year
      let endYear = startYear + 9; // Default to 10 years in the decade

      // For the 2020s, limit the years up to the current year (2026)
      if (startYear === 2020) {
        endYear = Math.min(currentYear, 2026); // Make sure to not exceed 2026
      }

      // Generate the years for the selected decade
      return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    },
  },
}
</script>

<style scoped>
/* Main Layout Match */
.content-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.1), 0 8px 10px -6px rgba(2, 132, 199, 0.05);
  padding: 2.5rem;
  margin-bottom: 2rem;
  border-top: 5px solid #0284c7;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.75rem;
  color: #0c4a6e;
  border: none;
  margin-bottom: 1.5rem;
  font-weight: 700;
}

.blue-accent {
  background: #0ea5e9;
  display: inline-block;
  width: 6px;
  height: 28px;
  margin-right: 12px;
  border-radius: 4px;
}

/* Modern Year Cards */
.year-card {
  background-color: #f8fafc;
  border: 1px solid #e0f2fe;
  border-radius: 12px;
  padding: 1.5rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(2, 132, 199, 0.05);
  position: relative;
  overflow: hidden;
}

.year-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #0ea5e9;
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: left;
}

.year-card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.folder-icon {
  font-size: 2rem;
  color: #7dd3fc;
  transition: all 0.3s ease;
}

.year-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  transition: color 0.3s ease;
}

/* Hover States */
.no-underline:hover .year-card {
  transform: translateY(-5px);
  background-color: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(2, 132, 199, 0.15), 0 4px 6px -2px rgba(2, 132, 199, 0.05);
  border-color: #bae6fd;
}

.no-underline:hover .year-card::before {
  transform: scaleX(1);
}

.no-underline:hover .folder-icon {
  color: #0284c7;
  transform: scale(1.1);
}

.no-underline:hover .year-text {
  color: #0284c7;
}

.no-underline {
  text-decoration: none !important;
  display: block;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/decadeComponent.vue